import { Check } from "@ews-admin/global-design-system";
import React from "react";

interface Step {
  id: string;
  title: string;
  description?: string;
}

interface StepsProps {
  steps: Step[];
  currentStep: number;
  completedSteps?: number[];
  className?: string;
}

export const Steps: React.FC<StepsProps> = ({
  steps,
  currentStep,
  completedSteps = [],
  className = "",
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-start">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = completedSteps.includes(stepNumber);
          const isCurrent = currentStep === stepNumber;
          const isUpcoming = currentStep < stepNumber;

          // Check if the connector line should be green (if current step is completed)
          const isConnectorCompleted = isCompleted;

          return (
            <div key={step.id} className="flex items-start flex-1">
              {/* Step Circle */}
              <div
                className={`flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 transition-colors flex-shrink-0 ${
                  isCompleted
                    ? "text-white bg-green-500 border-green-500"
                    : isCurrent
                      ? "text-white bg-blue-500 border-blue-500"
                      : isUpcoming
                        ? "text-gray-400 bg-gray-100 border-gray-300"
                        : "text-gray-400 bg-gray-100 border-gray-300"
                }`}
              >
                {isCompleted ? (
                  <Check className="w-4 h-4 sm:w-5 sm:h-5" />
                ) : (
                  <span className="text-xs sm:text-sm font-semibold">
                    {stepNumber}
                  </span>
                )}
              </div>

              {/* Step Content */}
              <div className="flex-1 ml-2 sm:ml-4 min-w-0">
                <div
                  className={`text-xs sm:text-sm font-medium ${
                    isCompleted || isCurrent ? "text-gray-900" : "text-gray-500"
                  }`}
                >
                  {step.title}
                </div>
                {step.description && (
                  <div
                    className={`text-xs mt-1 ${
                      isCompleted || isCurrent
                        ? "text-gray-600"
                        : "text-gray-400"
                    }`}
                  >
                    {step.description}
                  </div>
                )}
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-0.5 mx-1 sm:mx-2 mt-4 sm:mt-5 transition-colors ${
                    isConnectorCompleted ? "bg-green-500" : "bg-gray-300"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
